import {Language} from "../modules/common/enums/Language";
import en_US from "../locales/en-US";
import zh_CN from "../locales/zh-CN";

export const LanguageUtils = {
    CACHE_LANGUAGE: 'CACHE_LANGUAGE',

    getLocalText: (key: string) => {
        let message = '';
        const language = localStorage.getItem(LanguageUtils.CACHE_LANGUAGE);
        if (language === Language.Enum.enUS) {
            // @ts-ignore
            message = en_US[key] || key;
        } else {
            // @ts-ignore
            message = zh_CN[key] || key;
        }
        return message;
    },

    getLanguage: () => {
        return localStorage.getItem(LanguageUtils.CACHE_LANGUAGE);
    },

    setLanguage: (language: string) => {
        localStorage.setItem(LanguageUtils.CACHE_LANGUAGE, language);
    }
}